/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
    PalAuthPlatformToJSONTyped,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface FindAllPalAuthPlatforms200Response
 */
export interface FindAllPalAuthPlatforms200Response {
    /**
     * 
     */
    data?: Array<PalAuthPlatform>;
}

/**
 * Check if a given object implements the FindAllPalAuthPlatforms200Response interface.
 */
export function instanceOfFindAllPalAuthPlatforms200Response(value: object): value is FindAllPalAuthPlatforms200Response {
    return true;
}

export function FindAllPalAuthPlatforms200ResponseFromJSON(json: any): FindAllPalAuthPlatforms200Response {
    return FindAllPalAuthPlatforms200ResponseFromJSONTyped(json, false);
}

export function FindAllPalAuthPlatforms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalAuthPlatforms200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PalAuthPlatformFromJSON)),
    };
}

export function FindAllPalAuthPlatforms200ResponseToJSON(json: any): FindAllPalAuthPlatforms200Response {
    return FindAllPalAuthPlatforms200ResponseToJSONTyped(json, false);
}

export function FindAllPalAuthPlatforms200ResponseToJSONTyped(value?: FindAllPalAuthPlatforms200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PalAuthPlatformToJSON)),
    };
}

